import { Eye, EyeOff } from "lucide-react";
import { motion } from "framer-motion";
import { useFloatsVisibility } from "@/hooks/useFloatsVisibility";

/**
 * Tiny master toggle that hides/shows ALL floating buttons at once.
 * Lives in the bottom-left corner so it never overlaps the existing
 * floating stack on the right side or the agenda CTA at top-left.
 *
 * When floats are hidden, this button stays visible (always) and switches
 * its icon so the user can bring everything back.
 */
export const FloatsMasterToggle = () => {
  const { hidden, toggle } = useFloatsVisibility();
  return (
    <motion.button
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={toggle}
      data-testid="floats-master-toggle"
      aria-label={hidden ? "Mostrar botones flotantes" : "Ocultar botones flotantes"}
      title={hidden ? "Mostrar botones flotantes" : "Ocultar botones flotantes"}
      className="fixed bottom-3 left-3 z-[80] h-9 w-9 rounded-full bg-black/80 backdrop-blur-sm border border-[#d4af37]/40 text-[#d4af37] flex items-center justify-center shadow-lg hover:bg-black hover:border-[#d4af37]"
    >
      {hidden ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
    </motion.button>
  );
};
